import { put, call, select } from 'redux-saga/effects';
import { setProductsName, fetchProductsName } from '../actions';
import BaseMarginService from '@services/base-margin-service/baseMarginService';
import { selectSelectedCo } from '@app/store/filters-module/co';
import { TCommercialOrganization } from '@app/services/filter-service/response-interfaces/get-co.response';
import { ProductsName } from '@app/shared/types/baseMargin';
import { enqueSnackAction } from '@app/store/snacks';

export function* fetchProductsNameWorkerSaga(
  action: ReturnType<typeof fetchProductsName>
) {
  try {
    const selectedCo: TCommercialOrganization = yield select(selectSelectedCo);

    const result: ProductsName = yield call(
      BaseMarginService.fetchProductsName,
      {
        ...action.payload,
        coId: selectedCo.id,
      }
    );
    yield put(setProductsName({ payload: result }));
  } catch (e) {
    if (e.response && e.response.status === 409) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'create fatch product name error',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'create fetch product name error',
        },
      })
    );
    console.log(`Failed to get product name : ${e.toString()}`);
  }
}
